import useDepots from './useDepots';

export default useDepots;
